import { useState } from 'react'
import Sidebar from '../components/Sidebar'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import Info from '../components/Info'
import Hobbies from '../components/Hobbies'
import Experience from '../components/Experience'
import Footer from '../components/Footer'
import { about, education } from '../components/Info/Data'

export default function Home() {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)

  return (
    <>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <Navbar toggle={toggle}/>
        <Hero />
        <Info {...about}/>
        <Hobbies />
        <Info {...education}/>
        <Experience />
        <Footer />
    </>
  )
}
